import { render } from "./finishOnBoard.vue?vue&type=template&id=dea63b4a&scoped=true&ts=true"
import script from "./finishOnBoard.vue?vue&type=script&lang=ts"
export * from "./finishOnBoard.vue?vue&type=script&lang=ts"

import "./finishOnBoard.vue?vue&type=style&index=0&id=dea63b4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dea63b4a"]])

export default __exports__